import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'login-1',
        path: `${AUTH_PREFIX_PATH}/login-1`,
        component: React.lazy(() => import('views/auth-views/authentication/login-1')),
    }
]

export const protectedRoutes = [
    // User routes
    {
        key: 'company',
        path: `${APP_PREFIX_PATH}/company/about`,
        component: React.lazy(() => import('views/app-views/company/about/CompanyInfoView')),
    },
    {
        key: 'company-add',
        path: `${APP_PREFIX_PATH}/company/about/add`,
        component: React.lazy(() => import('views/app-views/company/about/CompanyAddForm')),
    },
    {
        key: 'company-edit',
        path: `${APP_PREFIX_PATH}/company/about/edit/`,
        component: React.lazy(() => import('views/app-views/company/about/CompanyEditForm')),
    },
    {
        key: 'reports',
        path: `${APP_PREFIX_PATH}/reports`,
        component: React.lazy(() => import('views/app-views/reports')),
    },
    {
        key: 'reports.quarterly-reports',
        path: `${APP_PREFIX_PATH}/reports/quarterly-reports`,
        component: React.lazy(() => import('views/app-views/reports/quarterly-reports')),
    },
    {
        key: 'reports.quarterly-reports.add-quarterly-report',
        path: `${APP_PREFIX_PATH}/reports/quarterly-reports/add-quarterly-report`,
        component: React.lazy(() => import('views/app-views/reports/quarterly-reports/add-report')),
    },
    {
        key: 'reports.quarterly-reports.edit-quarterly-report',
        path: `${APP_PREFIX_PATH}/reports/quarterly-reports/edit-quarterly-report`,
        component: React.lazy(() => import('views/app-views/reports/quarterly-reports/edit-report')),
    },
    {
        key: 'reports.quarterly-reports.view-quarterly-report',
        path: `${APP_PREFIX_PATH}/reports/quarterly-reports/view-quarterly-report`,
        component: React.lazy(() => import('views/app-views/reports/quarterly-reports/view-report')),
    },
    {
        key: 'reports.auditor-reports',
        path: `${APP_PREFIX_PATH}/reports/auditor-reports`,
        component: React.lazy(() => import('views/app-views/reports/auditor-reports')),
    },
    {
        key: 'contact',
        path: `${APP_PREFIX_PATH}/contact`,
        component: React.lazy(() => import('views/app-views/contact')),
    },

    // Admin routes
    {
        key: 'company-admin',
        path: `${APP_PREFIX_PATH}/admin/company`,
        component: React.lazy(() => import('views/admin-views/company')),
    },
    {
        key: 'admin-quarterly-reports',
        path: `${APP_PREFIX_PATH}/admin/quarter-report-admin`,
        component: React.lazy(() => import('views/admin-views/reports/quarter-report-admin')),
    },
    {
        key: 'admin-auditor-reports',
        path: `${APP_PREFIX_PATH}/admin/auditor-report-admin`,
        component: React.lazy(() => import('views/admin-views/reports/auditor-report-admin')),
    },
    {
        key: 'residents-application-list',
        path: `${APP_PREFIX_PATH}/admin/residents/application-list`,
        component: React.lazy(() => import('views/admin-views/residents')),
    },
    {
        key: 'residents-application-view',
        path: '/admin/residents/application-view/:id',
        component: React.lazy(() => import('views/admin-views/residents/ResidentApplicationView')),
    },
    
    {
        key: 'company-admin-add',
        path: `${APP_PREFIX_PATH}/admin/company/add`,
        component: React.lazy(() => import('views/admin-views/company/AddCompany')),
    },
    {
        key: 'company-admin-edit',
        path: `${APP_PREFIX_PATH}/admin/company/edit/:id`,
        component: React.lazy(() => import('views/admin-views/company/EditCompany')),
    },
    {
        key: 'company-admin-view',
        path: `${APP_PREFIX_PATH}/admin/company/view/:id`,
        component: React.lazy(() => import('views/admin-views/company/ViewCompany')),
    },
    {
        key: 'quarter-report-admin-view',
        path: `${APP_PREFIX_PATH}/admin/quarter-report-admin/view`,
        component: React.lazy(() => import('views/admin-views/reports/quarter-report-admin/ViewCompany')),
    },

    {
        key: 'send-message',
        path: `${APP_PREFIX_PATH}/admin/residents/send-message`,
        component: React.lazy(() => import('views/admin-views/message')),
    },
    {
        path: `${APP_PREFIX_PATH}/admin/general-reports`,
        component: React.lazy(() => import('views/admin-views/reports/general-report-admin')),
    },
    {
        key: 'staff-admin',
        path: `${APP_PREFIX_PATH}/admin/staff`,
        component: React.lazy(() => import('views/admin-views/staff')),
    },


    // Custom pages routes
    {
        key: 'welcome-page',
        path: `${APP_PREFIX_PATH}/welcome-page`,
        component: React.lazy(() => import('views/index')),
    }
]
